/**
 * The brief redis entry TTL - 30 days
 * @type {number}
 */
const BRIEF_REDIS_TTL = 60 * 60 * 60 * 24 * 30;

const ERROR_MESSAGE = {
    ID_MISSING: 'Missing required id param',
    REDIS_UNINITIALISED: 'Redis was not initialized'
};

module.exports = {
    BRIEF_REDIS_TTL,
    ERROR_MESSAGE
};
